export const mockServices = [
  {
    id: "residential",
    title: "Residential Architecture",
    tagline: "Homes that endure",
    description: "Custom homes, additions, and renovations for discerning clients across Santa Monica and Los Angeles. From concept through construction, we deliver residences of lasting character.",
    image: "https://public.readdy.ai/ai/img_res/3752f249ce7852de7699e5b5e5de09c9.jpg",
    href: "/services/residential",
    highlights: [
      "New custom home design",
      "Home additions & extensions",
      "Hillside and coastal projects",
      "ADU & accessory structures",
    ],
  },
  {
    id: "multi-family",
    title: "Multi-Family / Development",
    tagline: "Density done beautifully",
    description: "Apartment buildings, townhome communities, and mixed-use developments that add value to the neighborhood while maximizing investment return.",
    image: "https://readdy.ai/api/search-image?query=modern%20multi-family%20residential%20apartment%20building%20los%20angeles%2C%20contemporary%20urban%20architecture%2C%20clean%20facade%2C%20mixed%20use%20development%2C%20architectural%20photography%2C%20daytime%20blue%20sky&width=800&height=600&seq=14&orientation=landscape",
    href: "/services/multi-family",
    highlights: [
      "Mid-rise apartment design",
      "Townhome communities",
      "Mixed-use development",
      "ADU & lot-split strategies",
    ],
  },
  {
    id: "hospitality",
    title: "Hospitality Design",
    tagline: "Experiences built in space",
    description: "Hotels, restaurants, and resort spaces where architecture becomes part of the guest experience. We design for atmosphere, operations, and brand.",
    image: "https://readdy.ai/api/search-image?query=luxury%20boutique%20hotel%20lobby%20interior%20california%2C%20modern%20minimal%20design%2C%20warm%20natural%20materials%2C%20architectural%20photography%2C%20soft%20diffused%20light%2C%20high%20end%20hospitality%20space&width=800&height=600&seq=15&orientation=landscape",
    href: "/services/hospitality",
    highlights: [
      "Boutique hotels & resorts",
      "Restaurant & bar design",
      "Spa & wellness spaces",
      "Branded environments",
    ],
  },
  {
    id: "renovation",
    title: "Renovation",
    tagline: "Transform what exists",
    description: "Thoughtful renovation of homes and commercial spaces — preserving what matters, reimagining what doesn't, and making every square foot count.",
    image: "https://readdy.ai/api/search-image?query=beautiful%20residential%20renovation%20interior%20los%20angeles%20california%2C%20modern%20kitchen%20living%20space%2C%20white%20walls%2C%20natural%20wood%2C%20architectural%20photography%2C%20clean%20minimal%20aesthetic&width=800&height=600&seq=16&orientation=landscape",
    href: "/services/renovation",
    highlights: [
      "Whole-home renovations",
      "Kitchen & bath remodels",
      "Commercial tenant improvements",
      "Historic preservation",
    ],
  },
];

export const processSteps = [
  {
    number: "01",
    title: "Discovery",
    description: "We begin with a deep dive into your site, goals, and vision. This phase uncovers project constraints, opportunities, and defines the design brief.",
  },
  {
    number: "02",
    title: "Concept Design",
    description: "We develop multiple design concepts exploring form, massing, and spatial organization. Ideas are tested, refined, and presented for your feedback.",
  },
  {
    number: "03",
    title: "Design Development",
    description: "The selected concept is developed into detailed architectural drawings, including floor plans, elevations, sections, and material selections.",
  },
  {
    number: "04",
    title: "Permitting",
    description: "We prepare and submit a complete permit package to the relevant municipality, coordinating with structural engineers and other consultants.",
  },
  {
    number: "05",
    title: "Construction",
    description: "We provide construction administration services — reviewing submittals, answering RFIs, and conducting site visits to ensure the design intent is realized.",
  },
];

export const faqItems = [
  {
    question: "Who is the best architect near me in Santa Monica?",
    answer: "Studio 1323 is a leading architecture firm in Santa Monica with a proven portfolio of residential, multi-family, and hospitality projects across Los Angeles. Our team brings precision, design authority, and deep local expertise to every project — from custom homes in Malibu to mixed-use developments on Montana Avenue.",
  },
  {
    question: "How much does it cost to hire an architect?",
    answer: "Architectural fees typically range from 8–15% of total construction cost, depending on project scope and complexity. At Studio 1323, we offer transparent fee structures tailored to your project. We recommend requesting a consultation to discuss your specific scope and receive an accurate estimate.",
  },
  {
    question: "What does an architect do?",
    answer: "An architect designs buildings, prepares construction documents, navigates permitting, and oversees construction. At Studio 1323, we manage every phase — from the first sketch to final occupancy — ensuring your project meets design, safety, and regulatory requirements while expressing a clear architectural vision.",
  },
  {
    question: "Do I need an architect for a remodel?",
    answer: "For significant renovations — structural changes, additions, or projects requiring permits — an architect is essential. Studio 1323 handles renovation projects of all scales, guiding clients through the entitlement process in Santa Monica and Los Angeles municipalities and coordinating with contractors throughout construction.",
  },
  {
    question: "How long does an architectural project take?",
    answer: "A custom home typically takes 12–24 months from design through construction completion. Renovation projects may range from 6–18 months. Multi-family and hospitality projects vary widely. During your initial consultation, we'll outline a realistic project timeline specific to your scope and site.",
  },
  {
    question: "What sets Studio 1323 apart from other architecture firms?",
    answer: "Studio 1323 brings a portfolio-led approach to every project — each design is rooted in the specific site, client, and program rather than a signature style. Our Santa Monica base gives us deep local knowledge and established relationships with Los Angeles planning departments, contractors, and consultants.",
  },
];
